module.exports = __webpack_public_path__ + "media/images/result-null-state-new-b4c431211e866a06879e764a054db8dc.png";